var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2713",
    "data-name": "Group 2713",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.363,
    height: 38.363,
    viewBox: "0 0 38.363 38.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2723",
    "data-name": "Group 2723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2702",
    "data-name": "Group 2702",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2107",
    "data-name": "Group 2107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_3451",
    "data-name": "Path 3451",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.182,0A19.182,19.182,0,1,1,0,19.182,19.182,19.182,0,0,1,19.182,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19.181640625 1 C 14.32515144348145 1 9.759340286254883 2.891220092773438 6.325279235839844 6.325279235839844 C 2.891220092773438 9.759340286254883 1 14.32515144348145 1 19.181640625 C 1 24.03813171386719 2.891220092773438 28.60394096374512 6.325279235839844 32.03800201416016 C 9.759340286254883 35.47206115722656 14.32515144348145 37.36328125 19.181640625 37.36328125 C 24.03813171386719 37.36328125 28.60394096374512 35.47206115722656 32.03800201416016 32.03800201416016 C 35.47206115722656 28.60394096374512 37.36328125 24.03813171386719 37.36328125 19.181640625 C 37.36328125 14.32515144348145 35.47206115722656 9.759340286254883 32.03800201416016 6.325279235839844 C 28.60394096374512 2.891220092773438 24.03813171386719 1 19.181640625 1 M 19.181640625 0 C 29.77537155151367 0 38.36328125 8.587909698486328 38.36328125 19.181640625 C 38.36328125 29.77537155151367 29.77537155151367 38.36328125 19.181640625 38.36328125 C 8.587909698486328 38.36328125 0 29.77537155151367 0 19.181640625 C 0 8.587909698486328 8.587909698486328 0 19.181640625 0 Z",
    stroke: "none",
    fill: "#bebebe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2705",
    "data-name": "Group 2705",
    transform: "translate(13.19 13.319)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x2: 11.969,
    y2: 11.969,
    fill: "none",
    stroke: "#bebebe",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    y1: 11.969,
    x2: 11.969,
    fill: "none",
    stroke: "#bebebe",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.de19b04d6568dbcde972908b526abf9c.svg";
export { ForwardRef as ReactComponent };